import { create } from "zustand";

export type ToastKind = "default" | "ok" | "warn";

export interface Toast {
  msg: string;
  kind?: ToastKind;
  at: number;
}

interface ToastStore {
  current: Toast | null;
  show: (msg: string, kind?: ToastKind) => void;
  hide: () => void;
}

let timer: ReturnType<typeof setTimeout> | null = null;

export const useToastStore = create<ToastStore>((set) => ({
  current: null,
  show: (msg, kind = "default") => {
    if (timer) clearTimeout(timer);
    set({ current: { msg, kind, at: Date.now() } });
    timer = setTimeout(() => set({ current: null }), 1800);
  },
  hide: () => {
    if (timer) clearTimeout(timer);
    set({ current: null });
  },
}));
